/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OutputAllMenuPagesPermissionDto } from '../../models/output-all-menu-pages-permission-dto';

export interface UserManagementGetMenusPagesPermissionsGet$Params {
}

export function userManagementGetMenusPagesPermissionsGet(http: HttpClient, rootUrl: string, params?: UserManagementGetMenusPagesPermissionsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OutputAllMenuPagesPermissionDto>>> {
  const rb = new RequestBuilder(rootUrl, userManagementGetMenusPagesPermissionsGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<OutputAllMenuPagesPermissionDto>>;
    })
  );
}

userManagementGetMenusPagesPermissionsGet.PATH = '/UserManagement/GetMenusPagesPermissions';
